import { IncidentSeverity, IncidentTier } from "./types";

export const POINT_VALUES = {
    merit: 5,
    minor: -5,
    major: -15,
    critical: -30
};

export const TIER_THRESHOLDS = {
    tier1: 80, // Above 80 is Tier 1 (Green)
    tier2: 60, // 60-79 is Tier 2 (Orange)
    tier3: 0   // Below 60 is Tier 3 (Red)
};

export const calculateNewScore = (currentScore: number, type: 'merit' | 'demerit', severity?: IncidentSeverity): number => {
    let change = 0;
    if (type === 'merit') {
        change = POINT_VALUES.merit;
    } else {
        switch (severity) {
            case 'minor': change = POINT_VALUES.minor; break;
            case 'major': change = POINT_VALUES.major; break;
            case 'critical': change = POINT_VALUES.critical; break;
            default: change = 0;
        }
    }

    // Clamp between 0 and 100
    return Math.min(100, Math.max(0, currentScore + change));
};

export const determineTier = (score: number, currentTier: number, hasSafetyIncident: boolean): IncidentTier => {
    // Safety incidents automatically escalate to Tier 3
    if (hasSafetyIncident) return 3;

    if (score < TIER_THRESHOLDS.tier2) return 3;
    if (score < TIER_THRESHOLDS.tier1) return 2;
    return 1;
};

export const getSuggestedIntervention = (tier: IncidentTier, category: string): string => {
    if (tier === 3) return "Parent Conference & Suspension Hearing";
    if (tier === 2) return "Detention & Behavior Contract";
    return "Verbal Warning & Reflection";
};
